// Copyright (c) 2024-present, Dinocollab Technologies, Inc. and its affiliates. All rights reserved.

import { setViewModeToURL, getViewModeFromURL, setPaginationToURL, getPaginationFromURL } from './helpers'
import createViewGrid from './view-grid'
import ButtonSwitch from './button-switch'
import createDataSurface from './index.create'
import createViewList from './view-list'
import { PanelPaginationFooter } from './ui.units'

export class DinoDataSurFace {
  createDataSurface = createDataSurface
  createViewGrid = createViewGrid
  createViewList = createViewList
  ButtonSwitch = ButtonSwitch
  createButtonSwitch = () => ButtonSwitch
  PanelPaginationFooter = PanelPaginationFooter
  createPanelPaginationFooter = () => PanelPaginationFooter

  // helpers
  setViewModeToURL = setViewModeToURL
  getViewModeFromURL = getViewModeFromURL
  setPaginationToURL = setPaginationToURL
  getPaginationFromURL = getPaginationFromURL
}

export const dinoDataSurface = new DinoDataSurFace()
